import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_es_1c1f0101f224e2c4294be2ca2bb3f3de/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}